// extracted by mini-css-extract-plugin
export default {"richText":"RichText--richText--5oEJx","fontSizeBig":"RichText--fontSizeBig--BwZQr","pageThemeLight":"RichText--pageThemeLight--sO1mA"};